module.exports = __webpack_public_path__ + "static/media/dang.1627f8de.png";